import { Divider } from 'semantic-ui-react'
import UserForm from './UserForm'
import PasswordForm from './PasswordForm'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useBreadcrumb from '../../NavBar/useBreadcrumb'

const UserAccount = () => {
    const [t] = useTranslation()
    const {setPaths} = useBreadcrumb()

    useEffect(() => {
        setPaths([{
            text: t('breadcrumb.home'),
            link: true,
            path: '/',
        }, {
            text: t('administration.submenus.myAccount'),
            link: false,
        }])

    }, [setPaths, t])

    return (
      <>
          <UserForm/>
          <Divider/>
          <PasswordForm/>
      </>
    )

}

export { UserAccount }
